import Component from './serial_code_create.vue'
export default Component
